import { createSlice, Dispatch } from "@reduxjs/toolkit";
import { ReservationsService } from "../actions";

export const fetchAllReservations = () => async (dispatch: Dispatch) => {
  const response = await ReservationsService.getReservations();
  dispatch(setReservations(response));
};

export const fetchUpcomingReservations = () => async (dispatch: Dispatch) => {
  const response = await ReservationsService.getReservations(false);
  dispatch(setUpcomingReservations(response));
};

export const fetchPastReservations = () => async (dispatch: Dispatch) => {
  const response = await ReservationsService.getReservations(true);
  dispatch(setPastReservations(response));
};

interface ReservationsState {
  reservations: Array<any>;
  reservationsFetched: boolean;
  upcoming: Array<any>;
  past: Array<any>;
  upcomingFetched: boolean;
  pastFetched: boolean;
}

const initialState: ReservationsState = {
  reservations: [],
  reservationsFetched: false,
  upcoming: [],
  past: [],
  upcomingFetched: false,
  pastFetched: false,
};

const stateSlice = createSlice({
  name: "reservations",
  initialState,
  reducers: {
    setReservations: (state, action) => {
      state.reservations = action.payload;
      state.reservationsFetched = true;
    },
    setUpcomingReservations: (state, action) => {
      state.upcoming = action.payload;
      state.upcomingFetched = true;
    },
    setPastReservations: (state, action) => {
      state.past = action.payload;
      state.pastFetched = true;
    },
  },
});

export const { setReservations, setUpcomingReservations, setPastReservations } =
  stateSlice.actions;

export default stateSlice.reducer;
